import React from 'react'

import PageBanner from 'organisms/pageBanner'
import bannerPoster from 'assets/videos/general-nonwoven.webp'
import bannerVideo from 'assets/videos/general-nonwoven.mp4'
import nonwoven from 'assets/globals/nonwoven.svg'

export default function Banner() {
  return (
    <PageBanner
      bgVideo={bannerVideo}
      videoPoster={bannerPoster}
      pageName="Engineered for excellence"
      title="<strong class='font-semibold text-blue'>Customised Nonwoven</strong> solutions 
      <br class='md:block hidden' /> for specialized applications"
      subtitle=""
      icon={nonwoven}
      iconAlt="Supreme nonwoven"
      iconClasses="h-8 lg:h-10 w-auto object-contain object-center mx-auto mb-1 xl:mb-2 animate-fade opacity-0"
    />
  )
}
